import { createObservableInstance } from '../../helpers';
import UserImplDependedRefState from '../abstract/UserImplDependedRefState';
import PaymentsMapper from '../wrappers/PaymentsMapper';
import PaymentState from './PaymentState';

class PaymentsState extends UserImplDependedRefState {
  constructor(root) {
    super(root, {
      pathGetter: (userImpl) => `profiles/${userImpl.uid}/payments`,
      collection: {
        ItemClass: PaymentState,
      },
    });
  }

  init() {
    super.init();

    this.mapped = createObservableInstance(PaymentsMapper, this);
  }
}

PaymentsState.annotations = {
  ...UserImplDependedRefState.annotations,
};

export default PaymentsState;
